import type { ProductType } from '@data-access/graphql/schema.types'

import { trackEvent } from './track-event'

export type TrackViewItemPayload = {
  item_id: string
  item_name: string
  item_category: ProductType
  item_category2?: string
  item_category5?: string
  item_brand?: string
  item_has_reviews?: 'yes' | 'no'
  item_review_count?: number
}
export function trackViewItem(item: TrackViewItemPayload) {
  trackEvent({
    event: 'view_item',
    ecommerce: { items: [item] },
  })
}
